/* Alpacas Foods — carrinho AJAX (Cart API + Section Rendering). Porta MiniCart/cart.tsx.
   Sem React. Drawer atualizado via /?sections=alp-cart-drawer (sempre na raiz —
   em /collections/* o mesmo parâmetro na URL atual retorna 404). */
(function () {
  'use strict';
  var SECTION = 'alp-cart-drawer';
  var SECTION_WRAP_ID = 'shopify-section-' + SECTION;

  function sectionFetchUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + '?sections=' + SECTION;
  }

  function drawer() { return document.querySelector('.alp-cart'); }
  function backdrop() { return document.querySelector('.alp-cart-backdrop'); }

  function open() {
    var d = drawer(), b = backdrop();
    if (d) { d.classList.add('is-open'); d.removeAttribute('inert'); d.setAttribute('aria-hidden', 'false'); }
    if (b) b.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    var d = drawer(), b = backdrop();
    if (d) { d.classList.remove('is-open'); d.setAttribute('inert', ''); d.setAttribute('aria-hidden', 'true'); }
    if (b) b.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function updateCount(n) {
    var el = document.getElementById('alp-cart-count');
    if (!el) return;
    el.textContent = n;
    el.classList.toggle('is-empty', n === 0);
    if (n > 0) document.dispatchEvent(new CustomEvent('alp:cart:bump'));
  }

  function applySectionHtml(html) {
    var wrap = document.getElementById(SECTION_WRAP_ID);
    if (!wrap || html == null) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
    if (!fresh) return false;
    wrap.innerHTML = fresh.innerHTML;
    return true;
  }

  function fetchCartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) updateCount(cart.item_count); });
  }

  function refresh(thenOpen) {
    var openNow = drawer() && drawer().classList.contains('is-open');
    return fetch(sectionFetchUrl(), { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('section ' + r.status);
        return r.json();
      })
      .then(function (data) {
        applySectionHtml(data[SECTION]);
        if (openNow || thenOpen) open();
      })
      .catch(function () {
        /* Mesmo se a seção falhar, abre o drawer e atualiza o contador. */
        if (thenOpen) open();
      })
      .then(fetchCartCount);
  }

  // Abrir drawer pelo ícone do header.
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('#alp-cart-link');
    if (cartLink) { e.preventDefault(); refresh(true); return; }
    if (e.target.closest('[data-cart-close]')) { close(); return; }

    // Controles de linha no drawer.
    var line = e.target.closest('[data-cart-line]');
    if (line) {
      var idx = parseInt(line.getAttribute('data-cart-line'), 10);
      var qtyEl = line.querySelector('.alp-cart-item__qty span') || line.querySelector('.alp-qty span');
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (e.target.closest('[data-cart-plus]')) { change(idx, qty + 1); }
      else if (e.target.closest('[data-cart-minus]')) { change(idx, Math.max(0, qty - 1)); }
      else if (e.target.closest('[data-cart-remove]')) { change(idx, 0); }
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  function change(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () {
      if (document.querySelector('.alp-cartpage__grid')) { window.location.reload(); }
      else { refresh(false); }
    });
  }

  // Interceptar formulários de add-to-cart (cards, PDP, sticky).
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-alp-add]');
    if (!form) return;
    e.preventDefault();
    // e.submitter: o CTA fixo mobile fica FORA do form (associado via form="…").
    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'add ' + r.status);
          return data;
        });
      })
      .then(function () { return refresh(true); })
      .catch(function (err) {
        // Faixas de 6/12 unidades esbarram em estoque com frequência: sem aviso,
        // o cliente só via o botão parar de responder.
        var slot = form.querySelector('[data-alp-add-error]');
        if (slot) { slot.textContent = err.message; slot.hidden = false; }
        else { window.alert(err.message); }
      })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  });
})();
